import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDDuplicateData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDuplicateTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDDuplicateData): Promise<void> => {
      const result = await apiClient.tsd.duplicateTsd.mutation({ body: data });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage duplicated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error duplicating the temporary storage!`);
    },
  });
};
